import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  isLoading = false;

  constructor(
    private loadingController: LoadingController
  ) {     
    
  }

  async loadingRedirect(){
    this.isLoading = true;
    return this.loadingController.create({})
      .then(a =>{
        a.present().then(()=>{
          if(!this.isLoading){
            a.dismiss();
          }
        })
      });
  }

}
